import * as React from 'react';
export var IconMail = function IconMail() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M.91 0h14.15c.092 0 .182 0 .273.027L8 5.137.667.027C.757 0 .847 0 .91 0zM16 9.176c0 .467-.394.824-.91.824H.91C.393 10 0 9.643 0 9.176V.934L8 6.51l8-5.55v8.216z"
  }));
};